// @ts-nocheck
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { getImageUrl } from "../../../commons/assets_path";
import className from "./PulldownSearchForm.module.scss";
import { useTranslation } from "react-i18next";

/**
 * @arg {PropTypes.InferProps.<typeof OutputSuggest.propTypes>} props
 * @return {ReturnType.<React.FC>}
 */

export const PulldownSearchForm = ({ onSearchList, seacrhMethodType }) => {
  const { t } = useTranslation();
  const inputRef = useRef();
  return (
    <div className={className.searchForm}>
      <span style={{ padding: "7px 1px 7px 15px" }}>
        <img src={getImageUrl("images/icons/searchGray.svg")} width="20" height="20" />
      </span>
      <input
        type="text"
        placeholder={
          seacrhMethodType === "forwardMatch" ? t("PulldownSearchForm.検索（前方一致）") : t("PulldownSearchForm.検索")
        }
        ref={inputRef}
        className={className.searchInput}
        onChange={(e) => onSearchList(e.target.value)}
      />
      <div
        className={className.searchCancelButton}
        style={{ display: inputRef.current?.value ? "flex" : "none" }}
        onClick={() => {
          onSearchList("");
          inputRef.current.value = "";
        }}
      >
        <img src={getImageUrl("images/icons/grayCancel.svg")} style={{ width: "16px", height: "16px" }} />
      </div>
    </div>
  );
};

PulldownSearchForm.propTypes = {
  onSearchList: PropTypes.func,
  seacrhMethodType: PropTypes.string,
};
